import * as React from 'react';
import type {EngineConfig} from './EngineConfigProvider';
import {EngineConfigProvider} from './EngineConfigProvider';

export const EngineProvider: React.FC<
  React.PropsWithChildren<Partial<EngineConfig>>
> = ({children, ...config}) => {
  const stableConfig: EngineConfig = React.useMemo(
    () => ({
      cssPolicy: config.cssPolicy ?? 'runtime-only',
      useInsertion: config.useInsertion ?? false,
    }),
    [config.cssPolicy, config.useInsertion],
  );

  return (
    <EngineConfigProvider config={stableConfig}>
      {children}
    </EngineConfigProvider>
  );
};
